import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { CommonService } from "../../../shared/services/common.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { NotificationType } from "../../enums/notification-types.enum";
import { CustomerService } from "../../services/customer.service";
import { ReportService } from "../../services/report.service";

@Component({
    selector: 'app-pos-product-sales-report',
    templateUrl: '../../templates/template1/views/reports/pos-product-sales-report.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/pos-product-sales-report.less'
    ]
})
export class POSProductSalesReportComponent implements OnInit {
    @Input() storeId: [number];
    @Input() posLocationId: number;
    @Input() fromDate: string;
    @Input() toDate: string;
    @Output() isLoadedData = new EventEmitter<boolean>();
    @Output() addFavoriteEvent = new EventEmitter<boolean>();
    pageSizes = [50, 100, 150, 200];
    pageNumber: number = 1;
    pageSize: number = 50;
    pageCount: number = 0;
    isResponseError = false;
    isLoading = false;
    isAllProductSaleReportsLoading = false;
    isShowReport = true;
    reportResponse = null;
    allProductSaleReports = null;
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    csvType = FileUploadConstants.CSV_FILE_EXTENSION;
    printType = FileUploadConstants.PRINT;

    constructor(
        private _reportService: ReportService,
        private _translateService: TranslateService,
        private _customerservice: CustomerService,
        private _commonService: CommonService
    ) { }

    ngOnInit(): void {
        this.loadPOSProductSalesReports();
    }

    /**
     * To get POS product sales report
     * @returns void
     */
    getPOSProductSalesReport(): void {
        this.isLoading = true;
        this._reportService.getPOSProductSalesReport(this.storeId[0], this.posLocationId, this.fromDate, this.toDate, this.pageSize, this.pageNumber, false).subscribe(response => {
            if (response && response.content && response.content.length > 0) {
                this.reportResponse = response.content;
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.totalCount;
                this.isLoadedData.emit(true);
                // this.exportFile('csv');
            } else {
                this.setDefaultValue();
            }
        }, (error) => {
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.setDefaultValue();
        });
    }

    /**
     * To Set Default Values
     */
    setDefaultValue(): void {
        this.reportResponse = [];
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    }

    /**
     * To load product sales report
     * @returns void
     */
    loadPOSProductSalesReports(): void {
        this.isShowReport = true;
        // this.getPOSProductSalesReport();
        this.exportFile('csv');
    }

    /**
     * To change page size
     * @param  {number} pageSize
     * @returns void
     */
    pageSizeChange(pageSize: number): void {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getPOSProductSalesReport();
        }
    }

    /**
     * To change page number
     * @param  {number} pageNumber
     */
    pageChange(pageNumber: number): void {
        if (pageNumber) {
            this.pageNumber = pageNumber;
            this.getPOSProductSalesReport();
        }
    }

    /**
     * To emit add favorite event to parent component
     * @returns void
     */
    addToFavorite(): void {
        this.addFavoriteEvent.emit(true);
    }

    /**
     * To Export The file
    */
    exportFile(type): void {
        // if (this.allProductSaleReports && this.allProductSaleReports.length > 0) {
        //     this.download(type);
        // } else {
        //     this.fetchAllPOSProductSalesReports(type);
        // }
        this.fetchAllPOSProductSalesReports(type);
    }

    /**
     * To Fetch all product sale reports from service
     */
    fetchAllPOSProductSalesReports(type): void {
        this.isAllProductSaleReportsLoading = true;
        this.isLoading = true;
        this._reportService.getPOSProductSalesReport(this.storeId[0], this.posLocationId, this.fromDate, this.toDate, null, null, true).subscribe(response => {
            if (response && response.content && response.content.length > 0) {
                this.isAllProductSaleReportsLoading = false;
                this.allProductSaleReports = response.content;
                this.reportResponse = response.content;
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.totalCount;
                this.isLoadedData.emit(true);
                this.download(type);
            } else {
                this.isAllProductSaleReportsLoading = false;
                this.allProductSaleReports = [];
                this.setDefaultValue();
            }
        }, (error) => {
            this.isAllProductSaleReportsLoading = false;
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.allProductSaleReports = [];
            this.setDefaultValue();
        });
    }

    /**
     * To downlaod CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    download(type: string): void {
        const allProductSaleReportsLength = this.allProductSaleReports && this.allProductSaleReports.length ? 
            this.allProductSaleReports && this.allProductSaleReports.length : null;
        if (allProductSaleReportsLength > 0) {
            let columns = [
                this._translateService.get('customer-service.Item #')['value'],
                this._translateService.get('customer-service.Name')['value'],
                this._translateService.get('customer-service.Total Sales')['value']
            ];
            let rowdata = new Array<any>();
            let finalrows = new Array<any>();
            for (let i = 0; i < allProductSaleReportsLength; i++) {
                rowdata = [];
                let row = this.allProductSaleReports[i];
                rowdata.push(row.itemNumber);
                rowdata.push(row.productName);
                rowdata.push(row.totalSales);
                finalrows.push(rowdata);
            }
            const title = this._translateService.get('reports.POS Product Sales Report From')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === this.csvType) {
                this._customerservice.ExcelDownload(columns, finalrows, 'POS Product Sales Report', '', false);
            } else if (type === this.printType) {
                this._customerservice.constructTableAndPrint(columns, finalrows, title);
            }
        }
    }
}






// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/pos-product-sales-report.component.ts